var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06539 3C5.03662 3 4.16537 3.7361 4.02385 4.72486L2.01996 18.7249C1.84786 19.9273 2.81043 21 4.06151 21H19.9385C21.1896 21 22.1521 19.9273 21.98 18.7249L19.9762 4.72486C19.8346 3.7361 18.9634 3 17.9346 3H6.06539ZM9.68122 7C9.68122 8.24264 10.7194 9.25 12 9.25C13.2806 9.25 14.3188 8.24264 14.3188 7V6C14.3188 5.58579 14.6648 5.25 15.0917 5.25C15.5186 5.25 15.8646 5.58579 15.8646 6V7C15.8646 9.07107 14.1344 10.75 12 10.75C9.86562 10.75 8.13537 9.07107 8.13537 7V6C8.13537 5.58579 8.48142 5.25 8.90829 5.25C9.33517 5.25 9.68122 5.58579 9.68122 6V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag15);
export default __webpack_public_path__ + "static/media/shopping-bag-15.63eae2c3b2c2a8b7e3fa53e3873d4b82.svg";
export { ForwardRef as ReactComponent };